import React from 'react';
import styled from 'styled-components';
import { Button, Form, Input, Typography } from 'antd';
import { SourceBuilderState, StepProps } from './types';

const ControlsContainer = styled.div`
    gap: 8px;
    display: flex;
    margin-top: 8px;
    justify-content: space-between;
`;

export const NameSourceStep = ({ state, updateState, prev, submit }: StepProps) => {
    const setName = (stagedName: string) => {
        const newState: SourceBuilderState = {
            ...state,
            displayName: stagedName,
        };
        updateState(newState);
    };

    const onClickCreate = (shouldRun?: boolean) => {
        if (state.displayName !== undefined && state.displayName.length > 0) {
            submit(shouldRun);
        }
    };

    return (
        <>
            <Form layout="vertical">
                <Form.Item
                    required
                    label={
                        <Typography.Text strong style={{ marginBottom: 0 }}>
                            <span>Name</span>
                            <span className="f-color-risk-very-high">*</span>
                        </Typography.Text>
                    }
                    style={{ marginBottom: 24 }}
                >
                    <Typography.Paragraph>Give this ingestion source a name.</Typography.Paragraph>
                    <Input
                        data-testid="source-name-input"
                        className="source-name-input"
                        placeholder="My Redshift Source #2"
                        value={state.displayName}
                        onChange={(event) => setName(event.target.value)}
                    />
                </Form.Item>
            </Form>
            <ControlsContainer>
                <Button onClick={prev}>Previous</Button>
                <Button
                    onClick={() => onClickCreate(false)}
                    data-testid="ingestion-source-save-button"
                    disabled={!(state.displayName !== undefined && state.displayName.length > 0)}
                >
                    Save
                </Button>
                <Button
                    block
                    type="primary"
                    onClick={() => onClickCreate(true)}
                    disabled={!(state.displayName !== undefined && state.displayName.length > 0)}
                >
                    Save & Run Ingestion
                </Button>
            </ControlsContainer>
        </>
    );
};
